import { useRef, useEffect } from "react";
import { message } from "antd";
import { useLockFn } from "ahooks";
import { openDataModel } from "./openDataModel";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { AppDrawer } from "@/components/YhDrawer";
import { YhForm } from "@/components/YhFormBox";
import { creditFlagRender } from "@/utils/utils";
import { useGlobalModel } from "@/model/globalModel";
import { contractManageService } from "@/views/contract/manage/ContractManageService";


export const OpenDrawer = () => {

    const { user: { userName }, userBranch } = useGlobalModel(model => [model.user])
    const {
        selectedData, openDrawerVisible,
        setOpenDrawerVisible, onReset,
    } = openDataModel();

    useEffect(() => {
        if (openDrawerVisible) {
            formRef.current?.setFieldsValue({
                ...selectedData[0],
                creditFlag: creditFlagRender(selectedData[0].creditFlag),
                status: '',
                approver: userName,
                approvalTime: '自动生成'
            });
        }
    }, [openDrawerVisible])

    const formRef = useRef<IYhFormRef>();
    const formConfig: IYhForm = {
        labelCol: { span: 6 },
        disabled: false,
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "code",
                fieldName: "code",
                span: 0,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "账户实体",
                fieldName: "beName",
                disable: true,
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "授信类型",
                fieldName: "creditFlag",
                disable: true,
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "记账类型",
                fieldName: "accountTypeName",
                disable: true,
                span: 24,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "状态",
                fieldName: "status",
                span: 24,
                ds: [
                    { label: '审核通过', value: 2 },
                    { label: '审核驳回', value: 8 }
                ],
                rules: [{
                    required: true,
                    message: "状态为必选项！"
                }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "审核人",
                disable: true,
                fieldName: "approver",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "审核日期",
                disable: true,
                fieldName: "approvalTime",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 24,
            },
        ]
    };
    const onOk = useLockFn(async () => {
        try {
            let formData = await formRef.current?.validateFields();
            if (formData) {
                const reqData = {
                    ...formData,
                    "branch": userBranch,
                };
                let insertRet = await contractManageService.approval(reqData);
                if (insertRet.success) {
                    message.success("审核成功!");
                    onReset();
                    setOpenDrawerVisible(false);
                } else {
                    message.success("审核失败!" + insertRet.retMsg);
                }
            }
        } catch (e) {
            console.log("数据校验失败");
        }
    })
    const onCancel = () => {
        setOpenDrawerVisible(false);
    };
    return (
        <AppDrawer
            {...{
                title: "账户开户审核",
                visible: openDrawerVisible,
                onOk,
                onCancel,
                showFooter: true
            }}
        >
            <YhForm formRef={formRef} {...formConfig} />
        </AppDrawer>
    )
}
